// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_9--","cls2":"common-cls2_sp1 common-cls1_9--"};